import { useBehavior, useButton } from '@libs/hooks';
import { TButtonData, TWidgetProps } from '@libs/types';
import clsx from 'clsx';
import React, { Activity } from 'react';
import { TButtonOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import styles from './styles/buttonBanner.module.css';

export const ButtonBanner = ({ widget }: TWidgetProps<TButtonData, TButtonOption>) => {
    const data = widget.data ?? {};
    const { handleClick } = useButton(widget);
    const { isHidden, isDisabled } = useBehavior(widget);

    const className = clsx(styles.buttonBanner, isDisabled && styles.disabled);

    return (
        <Activity mode={isHidden ? 'hidden' : 'visible'}>
            <button
                className={className}
                data-test={widget.uid}
                aria-label={data.messages?.label}
                aria-disabled={isDisabled}
                aria-hidden={isHidden}
                disabled={isDisabled}
                onClick={() => handleClick()}
                style={getInlineStyles({ margin: widget.options?.margin })}
            >
                {data.messages?.label}
            </button>
        </Activity>
    );
};
